import React, { useState, useEffect } from "react";
import HrmSidebar from "Components/Common/HrmSidebar";
import PagesWrapper from "Components/Common/Pages/PagesWrapper";
import AppWrapper from "Components/Routes/AppWrapper";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import TableDetails from "Components/Common/TableDetails";
import DocumentApi from "api/hrmapi/document";
function DocumentDetails() {
  let params = useParams();
  const [dataToShow, setDataToShow] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    DocumentApi.viewDocumentApi(params)
      .then((response) => {
        const item = response.data
        const showData={
          id: item.id,
            name: item.name,
            required: item.required,
            issue_date: item.has_issue_date,
            expiry_date: item.has_expiry_date,
            document_no: item.has_document_no,
            created_at: item.created_at,
            company_id: item.company_id,
        }
        setDataToShow(showData);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        const errorMessage = error.response?.data.message
          ? error.response.data.message
          : "An error occurred";

        toast.error(`Error: ${errorMessage}`);
        setLoading(false);
      });
  }, []);
  return (
    <AppWrapper sideBar={<HrmSidebar />}>
      <PagesWrapper>
        <div className="w-full flex mb-4 justify-between items-center pt-4">
          <div className="text-24">Document Details #{params.id}</div>
        </div>
        <TableDetails data={dataToShow} loading={loading} />
      </PagesWrapper>
    </AppWrapper>
  );
}

export default DocumentDetails;
